import request from '@/lib/request';

const api = {};

api.listSettlementBill = reqData => request({
  url: 'v3/settlement_ops/account/list_settlement_bill',
  method: 'post',
  data: reqData,
});

api.getCityInfo = reqData => request({
  url: 'v1/settlement_account/get_city_info',
  method: 'post',
  data: reqData,
});

api.cashOutHistory = reqData => request({
  url: 'v3/settlement_ops/account/cash_out_history',
  method: 'post',
  data: reqData,
});

api.enterSettlement = reqData => request({
  url: 'v3/settlement_ops/account/user_info',
  method: 'post',
  data: reqData,
});

api.bankDeposit = reqData => request({
  url: '/v3/settlement_ops/account/bank_info',
  method: 'post',
  data: reqData,
});

api.batchDownloadSettlementDoc = reqData => request({
  url: 'v3/settlement_ops/account/mcn_bills_zip',
  method: 'post',
  data: reqData,
});

api.downloadBill = reqData => request({
  url: 'v3/settlement_ops/export/settlement_bill',
  method: 'post',
  data: reqData,
});

api.bindBank = reqData => request({
  url: 'v3/settlement_ops/account/bank_bind',
  method: 'post',
  data: reqData,
  autoErrorTips: false,
});

api.withdrawal = reqData => request({
  url: 'v3/settlement_ops/account/settlement_bill',
  method: 'post',
  data: reqData,
});

api.cashBankInfo = reqData => request({
  url: 'v3/settlement_ops/account/cash_bank_info',
  method: 'post',
  data: reqData,
});

api.getAccountInfo = reqData => request({
  url: 'v3/settlement_ops/account/before_bank_bind',
  method: 'post',
  data: reqData,
});

export default api;
